import { CheckOutlined, EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { memo } from "react";

import {
    StyledActionsContainer,
    StyledCapturedImage,
    StyledTextButton,
    StyledViewContainer,
} from "../../Styled";

interface CapturedModeProps {
    capturedImage: string;
    onRetake: () => void;
    onEdit: () => void;
    onConfirm: () => void;
}

export const CapturedMode = memo(
    ({ capturedImage, onRetake, onEdit, onConfirm }: CapturedModeProps) => (
        <>
            <StyledViewContainer>
                <StyledCapturedImage src={capturedImage} alt="Captured" />
            </StyledViewContainer>

            <StyledActionsContainer justify="center" align="center" gap={16}>
                <StyledTextButton size="large" onClick={onRetake} type="text">
                    Перезняти
                </StyledTextButton>

                <Button
                    icon={<EditOutlined />}
                    onClick={onEdit}
                    size="large"
                    type="default"
                    style={{ borderRadius: "50%" }}
                />

                <Button
                    icon={<CheckOutlined />}
                    onClick={onConfirm}
                    size="large"
                    type="primary"
                    style={{ borderRadius: "50%" }}
                />
            </StyledActionsContainer>
        </>
    ),
);

CapturedMode.displayName = "CapturedMode";
